import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonComponent } from '../../../shared/button/button.component';
import { PageNavigationService } from '../../../../services/page-navigation.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { navigationItems, NavItem } from '../../../../constants/navigation';
import { MatDividerModule } from '@angular/material/divider';
import { NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { filter } from 'rxjs';

@Component({
    selector: 'app-side-menu',
    imports: [ButtonComponent, MatButtonModule, MatIconModule, RouterModule, MatDividerModule, CommonModule, MatExpansionModule],
    templateUrl: './side-menu.component.html',
    styleUrl: './side-menu.component.scss'
})
export class SideMenuComponent {
  @Output() closeSideMenu = new EventEmitter();
  
  public navItems: NavItem[] = navigationItems;
  public openedItem?: string;
  public currentParent?: string;

  constructor(private navigationService: PageNavigationService, private router: Router) {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd || event instanceof NavigationStart)
    ).subscribe((event: NavigationEnd | NavigationStart) => {
      if (event instanceof NavigationEnd) {
        this.currentParent = this.navItems.find(
          item =>
            item.children &&
            (event.url === "/" + item.nav || item.children.find(child => event.url === "/" + child.nav))
        )?.nav;
        this.openedItem = this.currentParent;
      } else {
        this.resetMenu();
      }
    });
  }

  public goToContactForm() {
    this.resetMenu();
    this.navigationService.scrollTo('contactUs', ['/home']);
  }

  public goToFreeTrial() {
    this.resetMenu();
    this.navigationService.scrollTo('suites', ['/relief-apps']);
  }

  public goTo(id: any) {
    this.resetMenu();
    this.navigationService.scrollTo(id, ['/home']);
  }

  private resetMenu() {
    this.closeSideMenu.emit();
    this.openedItem = undefined;
  }
}
